
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Slum Soccer </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm sjan-award section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h4>Slum Soccer – Social Inclusion<span >  Intercollegiate Soccer Tournament</span> </h4>

        </div>
        <div class="sec-title text-center">
            <h2>Slum Soccer –  <span> Award</span></h2>
            <p>SJAN- Raisoni Achievers annual sports awards distributed Nagpur</p>
        </div>
        <div class="row">
            <div class="col-md-8">
                <p> Raisoni Group of Institutions collaborated with Slum Soccer- Krida Vikas Sanstha to celebrate
                    National Sports Day. The event was a two-day Social Inclusion Tournament, held on August 28th and
                    29th, 2022, with the objective of fostering social equality and inclusion among young people from
                    diverse socio-economic backgrounds.</p>

                <p> The tournament featured a 9-a-side football league cum knockout tournament and explored
                    opportunities to create positive pathways in slums, where underprivileged youth were given the
                    opportunity to participate. Eight zones from the Nagpur region participated, with each zone
                    consisting of 16 teams, for a total of 128 teams. The top 2 teams from each zone played a final
                    round with 16 teams for the UNC, Unity trophy.</p>
                <p>The tournament featured eight teams from various colleges, including Slum Soccer- Krida Vikas
                    Sanstha, and provided a platform for participants from slum areas to play with college football club
                    students. This gave players a unique opportunity to interact with peers from different backgrounds,
                    emphasizing their important role in society and promoting the idea of social inclusion. The matches
                    were not limited to basic football games but also included innovative games aimed at raising
                    awareness about social issues and their solutions in a simple way.</p>

                <p>Raisoni Group has always been committed to supporting noble causes. The success of this initiative
                    is a testament to the Raisoni Group's vision of creating a more equitable society and empowering
                    underprivileged sections of society. Overall, the event was a huge success and will undoubtedly
                    inspire more such events and initiatives aimed at creating a more inclusive and progressive society.

                </p>

            </div>


            <div class="col-md-4">
                <iframe width="100%" height="600"
                    src="https://drive.google.com/file/d/1dpPeP2xb135ETaXETux44WkD195NB8fg/preview" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>


        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                    </div>
                    <iframe width="100%" height="230"
                        src="https://drive.google.com/file/d/1LjOl4tw8cHZiAgrdhHiD5-RgnNsjr7Lt/preview" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>

                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="https://drive.google.com/drive/folders/1gHq6GQYN5Zt3ZXy46gCF6uKLGWgIra7i"
                                target="_blank" class="cmn-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-1.png"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-1.png">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-1.png"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-2.png"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-2.png">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-2.png"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-3.png"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-3.png">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/slum-soccer-3.png"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>



                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
